import React from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import { Title } from '../Procedure.styled';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import RowItemContainer from './rowContainer';
import {
    SelectBiologics,
    BiologicsDetailsheaderwrapper,
} from './BiologyUsed.styled';
import { sizes } from 'src/styles/Media.styled';
import media from 'src/styles/Media.styled';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NOT_VISIBLE } from 'src/constants/appConstants';
import { useSelector } from 'react-redux';
import {
    FONT_FAMILY_REGULAR,
    BLACK_FONT_COLOR,
    SEMANTIC_TEXT_PX,
    BASE_TEXT_PX,
    SMALL_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

const BiologicsUsedCard = ({
    biologicsUsedData,
    biologicsDetailData,
    showBiologisDetails,
    checkboxSelectionChangeHandler,
    isEquity,
    paddingLeftFRow,
    paddingLeftSRow,
}) => {
    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(1),
            // margin: 'auto',
            // maxWidth: 500,
        },
        image: {
            width: 128,
            height: 128,
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },
        gridPadBottom: {
            paddingBottom: 8,
        },
    }));
    const classes = useStyles();
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const isMobileView = winWidth < sizes.smalDevice;
    const biologicsDetail = useSelector(
        (state) => state.loginReducer.biologicsDetail
    );
    const ShowAllBiologicsUsed = () => {
        return (
            <>
                {biologicsDetail?.ruleValue !== NOT_VISIBLE && <Box
                    className={classes.paper}
                    my={1}
                    bgcolor={'#ffffff'}
                    borderRadius={6}
                    style={{
                        fontSize:{SMALL_TEXT_PX},
                        overflow: 'hidden',
                        padding: '0',
                        borderRadius: '0',
                    }}
                >
                    <SelectBiologics
                        showAstrisk={true}
                        style={{
                            padding: '16px 22px',
                            overflow: 'hidden',
                        }}
                    >
                        {t(
                            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.selectAllMsg'
                        )}
                    </SelectBiologics>
                    <BiologicsDetailsheaderwrapper>
                        <div
                            style={{
                                background: '#E8E8E8',
                                height: '34px',
                                alignContent: 'center',
                                marginTop: '14px',
                                width: '100%',
                                padding: '6px 0',
                            }}
                        >
                            <Grid container item alignItems={'flex-start'}>
                                {window.innerWidth <= sizes.mobileDevice ? (
                                    <>
                                        <Grid container item>
                                            <Grid item lg={6} md={6} xs={6}>
                                                <StyledHeader
                                                    padding={'0 0 0 22px'}
                                                >
                                                    {t(
                                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.biologics'
                                                    )}
                                                </StyledHeader>
                                            </Grid>

                                            <Grid
                                                item
                                                lg={3}
                                                md={3}
                                                xs={3}
                                                style={{
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                <StyledHeader>
                                                    {t(
                                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.medtronic'
                                                    )}
                                                </StyledHeader>
                                            </Grid>
                                            <Grid
                                                item
                                                lg={3}
                                                md={3}
                                                xs={3}
                                                style={{
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                <StyledHeader>
                                                    {t(
                                                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.competitive'
                                                    )}
                                                </StyledHeader>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        <Grid
                                            item
                                            xs={6}
                                            lg={6}
                                            md={6}
                                            sm={6}
                                            style={{ paddingLeft: '22px' }}
                                        >
                                            {t(
                                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.biologics'
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={3}
                                            lg={3}
                                            md={3}
                                            sm={3}
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t(
                                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.medtronic'
                                            )}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={3}
                                            lg={3}
                                            md={3}
                                            sm={3}
                                            style={{
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t(
                                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.competitive'
                                            )}
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </div>
                    </BiologicsDetailsheaderwrapper>
                </Box>}

                {biologicsDetail?.ruleValue !== NOT_VISIBLE && <Grid style={{ padding: '0px 16px 16px 16px' }}>
                    {biologicsDetailData &&
                        biologicsDetailData.map((item, index) => (
                            <RowItemContainer
                                isEquity={isEquity}
                                paddingLeftFRow={paddingLeftFRow}
                                paddingLeftSRow={paddingLeftSRow}
                                key={index}
                                classes={classes}
                                item={item}
                                index={index}
                                checkboxSelectionChangeHandler={
                                    checkboxSelectionChangeHandler
                                }
                            />
                        ))}
                </Grid>}
            </>
        );
    };

    return (
        <>
            <BiologicsUsedCardWrapper>
                <Box
                    my={1}
                    bgcolor={'#ffffff'}
                    boxShadow={'0px 0px 6px #00000029'}
                    borderRadius={5}
                    width={'99.66%'}
                    marginLeft={'1px'}
                    marginRight={'1px'}
                    marginBottom={'2rem'}
                    position={'relative'}
                    border={
                        biologicsUsedData.filter((item) => item.isSelected)
                            .length > 0
                            ? '1px solid #12C8F7'
                            : ''
                    }
                    className={'style-box-container'}
                >
                    <Title
                        mbpaddingBtm={'20px'}
                        paddingTop={'16px'}
                        paddingRight={'22px'}
                        paddingLeft={'22px'}
                        mbpaddingTop={'16px'}
                        mbpaddingRight={'22px'}
                        mbpaddingLeft={'22px'}
                        fontSize={BASE_TEXT_PX}
                    >
                        <span>
                            {t(
                                'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.title'
                            )}
                        </span>
                        <span className="asterisk">*</span>
                    </Title>
                    {isMobileView && (
                        <Grid item xs={12} style={{ paddingBottom: '12px' }}>
                            <Divider />
                        </Grid>
                    )}
                    {biologicsUsedData.length > 0 && (
                        <Grid container style={{ marginTop: '10px' }}>
                            {biologicsUsedData.map((obj, index) => {
                                return (
                                    <>
                                        <Grid
                                            container
                                            item
                                            lg={isEquity ? 6 : 4}
                                            md={isEquity ? 6 : 4}
                                            xs={12}
                                            key={obj.code}
                                        >
                                            <StyledCheckbox>
                                                <Checkbox
                                                    justifyContent={'flex-end'}
                                                    id={obj.code}
                                                    checked={obj.isSelected}
                                                    label={obj.description}
                                                    margin={'3px 0 0 0'}
                                                    labelStyleObj={{
                                                        fontFamily: FONT_FAMILY_REGULAR,
                                                        textAlign: 'left',
                                                        fontSize: SEMANTIC_TEXT_PX,
                                                        letterSpacing:
                                                            '-0.12px',
                                                        color: BLACK_FONT_COLOR,
                                                        opacity: 1,
                                                        padding: '0 0 17px 17px !important',
                                                    }}
                                                    onCheckboxSelectionChange={(
                                                        e
                                                    ) =>
                                                        checkboxSelectionChangeHandler(
                                                            e,
                                                            'biologicsUsed',
                                                            index,
                                                            obj.code
                                                        )
                                                    }
                                                />
                                            </StyledCheckbox>
                                        </Grid>
                                    </>
                                );
                            })}
                        </Grid>
                    )}

                    {!(
                        biologicsDetailData?.[0] === 'ADDITIONAL_PROCEDURE_DATA'
                    ) && showBiologisDetails ? (
                        <ShowAllBiologicsUsed />
                    ) : null}
                </Box>
            </BiologicsUsedCardWrapper>
        </>
    );
};

export default BiologicsUsedCard;

const StyledHeader = styled.div`
    width: ${({ width }) => (width ? width : '')};
    display: ${({ display }) => (display ? display : '')};
    padding: ${({ padding }) => (padding ? padding : '')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : ''};
`;

const StyledCheckbox = styled.div`
    height: 50px;
    padding: 0 22px;
`;

const BiologicsUsedCardWrapper = styled.div`
    .style-box-container {
        ${media.mobileDevice`
            margin-bottom: 30px !important;
        `}
        @media screen and (max-device-width: 360px) {
            margin-bottom: 30px !important;
        }
    }
`;
